export function toFixedWithoutRounding(num, fractionDigits) {
  const min = 0.000001;

  if ((num > 0 && num < min) || (num < 0 && num > -min)) {
    // HACK: below this js starts to turn numbers into exponential form like 1e-7.
    // This gives wrong results so we are just changing the original number to 0 here
    // as we don't need such small numbers anyway.
    num = 0;
  }
  const re = new RegExp("^-?\\d+(?:.\\d{0," + (fractionDigits || -1) + "})?");
  return Number(Number(num?.toString().match(re)?.[0]).toFixed(fractionDigits));
}
